module.exports = __webpack_public_path__ + "img/bedroom_thumb.fd25ed5a.jpg";